$shm_hitalama_map_widget_float_group $shm_hitalama_map_widget_float
	auto /
		^
		<= set_relatives null
		<= fit_to_widgets_auto null
	tools_custom /
		<= Count $mol_view
			sub / <= count_title \
		<= Ungroup $mol_button_minor
			hint \Ungroup
			sub /
				<= Ungroup_icon $mol_icon_ungroup
			click? <=> ungroup? null
